(function($) {
  'use strict';
  $(function() {


    $(window).scroll(function () {
      if ($(window).scrollTop() <= 1) {
        $('body').removeClass('scrolled');
        // $('#nav-icon1').removeClass('scrolled');
      } else {
        $('body').addClass('scrolled');
        // $('#nav-icon1').addClass('scrolled');
      }
      if ($('html, body').css('overflow') === 'auto') {
        $('html, body').css('overflow', 'visible');
      }
    });

    $(window).resize(function () {
      if ($(window).width() > 767) {
        if ($('header').hasClass('open')) {
          $('header').removeClass('open');
          $('.mobile-menu-toggle .text').text('Meny');
        }
      }
    });

    //Gift select something something error.
    $('.webform-submission-donation-form').submit(function(e) {
      if($('.webform-submission-form .nice-select .list li:first').hasClass('selected')) {
        $('<div class="form-item select-error-custom"><i class="zmdi zmdi-alert-triangle"></i> Vänligen välj ett alternativ för att gå vidare</div>').insertAfter('.form-item-purpose.js-form-item-purpose');
        return false;
      }
      else {
        if($('.select-error-custom').length) {
          $('.select-error-custom').remove();
        }
        return;
      }
    });

    // Set <header> top value
    if ($('#toolbar-administration').length) {
      var stickyHeight = getToolbarHeight();
      $('header').css({
        'top': stickyHeight,
      });

      // Toolbar height listener
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutationRecord) {
          var stickyHeight = getToolbarHeight();
          $('header').css({
            'top': stickyHeight,
          });

        });
      });

      var target = $('body')[0];
      observer.observe(target, { attributes: true, attributeFilter: ['style'] });
    }

    // Section item video body
    if ($('.section-item').find('.video-embed-field-responsive-video').length) {
      $(this).css('display', 'block !important');
    }

    // Section youtube link
    $('a.open-modal').click(function (e) {
      e.preventDefault();
      $(this).siblings('.modal-wrapper').css('display', 'block');
    });
    $('.modal-wrapper:not(iframe)').click(function () {
      $(this).css('display', 'none');
      // var youtubePlayer = document.getElementById('player');
      // youtubePlayer.pauseVideo();
      document.getElementById('iframe-player').contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    });

    // Mobile menu visibility
    $('.mobile-menu-toggle').click(function () {
      if ($(this).parents('header').hasClass('open')) {
        $(this).parents('header').removeClass('open');
        $(this).find('.text').text('Meny');
      } else {
        $(this).parents('header').addClass('open');
        $(this).find('.text').text('Stäng');
      }
    });

    // Side menu visibility
    $('.side-menu-toggle').click(function () {
      if ($('.side-menu-wrapper').hasClass('open')) {
        $('.side-menu-wrapper').removeClass('open');
        // $('.menu__toggle').removeClass('active');
        // $('#block-mainnavigation').slideToggle("fast");
      } else {
        $('.side-menu-wrapper').addClass('open');
        // $('.menu__toggle').addClass('active');
        // $('#block-mainnavigation').slideToggle("fast");
      }
    });

    // Newsletter popup ❤️
    if ($('body.path-frontpage').length) {
      if (getCookie('hideNewsLetterPopUp') != '1') {
        setTimeout(function () {
          $('.newsletter-popup').addClass('open');
        }, 8000);
      }
    }

    $('.newsletter-popup .popup-close').click(function () {
      $('.newsletter-popup').removeClass('open');
      setCookie('hideNewsLetterPopUp', '1');
    });
    $('form[name=mc-embedded-subscribe-form]').each(function() {
      $(this).submit(function (e) {
        setCookie('hideNewsLetterPopUp', '1', 5 * 365);
        $('.newsletter-popup').removeClass('open');
      });
    });

    $(document).on('mousedown keydown', function (e) {
      if ($('.side-menu-wrapper').hasClass('open')) {
        var container = $('.side-menu-wrapper');
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          $('.side-menu-wrapper').removeClass('open');
        }
      }
    });

    // Menu children visibility
    $('.menu-children-toggle').click(function () {
      $(this).parent('li.has-children').toggleClass('open');
    });

    // Donation block
    $('#block-gavoblocksidtopp-2 .string').on('click', function() {
      if ($(this).hasClass('active')) {
        $(this).removeClass('active').next('.text_long').hide('fast');
      } else {
        $('#block-gavoblocksidtopp-2 .string').removeClass('active');
        $('#block-gavoblocksidtopp-2 .text_long').hide('fast');
        $(this).addClass('active').next('.text_long').show('fast');
      }
    });
    $('#block-gavoblocksidtopp .field_alt_1_title').addClass('active');
    $('#block-gavoblocksidtopp .string').on('click', function() {
      if (!$(this).hasClass('active')) {
        $('#block-gavoblocksidtopp .string').removeClass('active');
        $(this).addClass('active');
        var donation_index = $(this).index();
        $('#block-gavoblocksidtopp .text_long').hide();
        $('#block-gavoblocksidtopp .text_long').eq(donation_index).show();
      }
    });

    // Dibs block
    $('#block-dibs .tabs>div').on('click', function() {
      if (!$(this).hasClass('active')) {
        $('#block-dibs .tabs>div').removeClass('active');
        var active_element = $(this).attr('class');
        $(this).addClass('active');
        $('#block-dibs .content>div').hide();
        $('#block-dibs .content .' + active_element).show('fast');
      }
    });

    $('.cart-form #edit-actions').prepend('<button data-href="/gava" class="button cta white">Handla mer</button>');

    $('.cart-form #edit-actions button.button').on('click', function(e) {
      e.preventDefault();
      window.location.href = $(this).attr('data-href');
    })


    // FAQ
    $('.faq-question').click(function () {
      $(this).toggleClass('open');
      $(this).siblings('.faq-answer').toggle('fast');
    });

    // Person
    $('.node--type-person').hover(
      function () {
        $(this).find('.links').show('fast');
      },
      function () {
        $(this).find('.links').hide('slow');
      }
    );

    // Event
    if ($('body.page-node-type-event').length && $('.paragraph--type--body-action-webform').length) {
      $('<a href="#section-webform" class="cta turquoise form-anchor">Anmäl dig till eventet</a>').insertAfter('.info-content .bottom');
    }

    // Select all links with hashes
    $('a[href*="#"]')
      // Remove links that don't actually link to anything
      .not('[href="#"]')
      .not('[href="#0"]')
      .click(function(event) {
        // On-page links
        if (
          location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '')
          &&
          location.hostname == this.hostname
        ) {
          // Figure out element to scroll to
          var target = $(this.hash);
          target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
          // Does a scroll target exist?
          if (target.length) {
            // Only prevent default if animation is actually gonna happen
            event.preventDefault();
            $('html, body').animate({
              scrollTop: target.offset().top - 62
            }, 1000, function() {
              // Callback after animation
              // Must change focus!
              var $target = $(target);
              $target.focus();
              if ($target.is(":focus")) { // Checking if the target was focused
                return false;
              } else {
                $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
                $target.focus(); // Set focus again
              };
            });
          }
        }
      });

    // Operational area set active
    if ($('.node--type-operational-area.node--view-mode-full').length) {
      var op_id = $('.node--type-operational-area.node--view-mode-full').attr('data-nid');
      $('.view--operational_areas-block_3').find('.link-wrapper.nid-'+ op_id + ' a').addClass('active');
    }

    // IE image fix
    if (!Modernizr.objectfit) {
      $('.decorator__background').each(function () {
        var $wrapper = $(this),
          imgUrl = $wrapper.find('img').prop('src');
        if (imgUrl) {
          $wrapper
            .css('backgroundImage', 'url(' + imgUrl + ')')
            .addClass('compat-object-fit')
            .children('img').hide();
        }
      });
      // Replace closure SVG image with inline SVG
      // $('#block-footercontact img[src$=".svg"]').each(function () {
      //   var $img = jQuery(this);
      //   var imgURL = $img.attr('src');
      //   var attributes = $img.prop("attributes");

      //   $.get(imgURL, function (data) {
      //     // Get the SVG tag, ignore the rest
      //     var $svg = jQuery(data).find('svg');

      //     // Remove any invalid XML tags
      //     $svg = $svg.removeAttr('xmlns:a');

      //     // Loop through IMG attributes and apply on SVG
      //     $.each(attributes, function () {
      //       $svg.attr(this.name, this.value);
      //     });

      //     // Replace IMG with SVG
      //     $img.replaceWith($svg);
      //   }, 'xml');
      // });
    }

    // $('.menu-close').click(function () {
    //   if ($('#block-mainnavigation').hasClass('open')) {
    //     $('#block-mainnavigation').removeClass('open');
    //     $('.menu__toggle').removeClass('active');
    //     $('#block-mainnavigation').slideToggle("fast");
    //   } else {
    //     $('#block-mainnavigation').addClass('open');
    //     $('.menu__toggle').addClass('active');
    //     $('#block-mainnavigation').slideToggle("fast");
    //   }
    // });


    // $('.block-facet--dropdown select.facets-dropdown').niceSelect();

    $('#mc-embedded-subscribe').click(function() {
      fbq('trackCustom', 'SubscribeNewsletter');
    });

    // Helper functions

    function getToolbarHeight() {
      var toolbarTabOuterHeight = $('#toolbar-bar').find('.toolbar-tab').outerHeight() || 0;
      var toolbarTrayHorizontalOuterHeight = $('.is-active.toolbar-tray-horizontal').outerHeight() || 0;
      return toolbarTabOuterHeight + toolbarTrayHorizontalOuterHeight;
    };
    function setCookie(name, value, days) {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }
    function getCookie(name) {
      var nameEQ = name + "=";
      var ca = document.cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }
    function eraseCookie(name) {
      document.cookie = name + '=; Max-Age=-99999999;';
    }
  });
})(jQuery);

(function (Drupal, $) {
  Drupal.behaviors.op_area_filter = {
    attach: function (context, settings) {
      $('#views-exposed-form-news-block-2 select', context).niceSelect();
      $('#edit-field-related-operation-areas-target-id').change(function () {
        $('form#views-exposed-form-news-block-2').submit();
      });
      $('select[data-drupal-selector="edit-purpose"]', context).niceSelect();
      $('select[data-drupal-selector="edit-bank"]', context).niceSelect();
      $('select[name="billecta_bank_account"]', context).niceSelect();
      $('select[data-drupal-selector="edit-field-donation-product-category-target-id"]', context).niceSelect();
    }
  }

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  function getMobileOperatingSystem() {

    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return "Windows Phone";
    }

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
  }

  // Drupal.behaviors.addButtonsToQuantity = {
  //   attach: function (context, settings) {
  //     $('.field--widget-commerce-quantity', context).each(function() {
  //       var $input = $(this).find('input'),
  //       incrementCb = function() {
  //         var newVal = parseInt($input.val()) + 1;
  //         $input.val(newVal);
  //       },
  //       incrementEl = $('<span class="add-to-cart-button add-to-cart-button-increment">+</span>').click(incrementCb),
  //       decrementCb = function() {
  //         var newVal = parseInt($input.val())  - 1;
  //         if(newVal >= 1) {
  //           $input.val(newVal);
  //         }
  //       },
  //       decrementEl = $('<span class="add-to-cart-button add-to-cart-button-decrement">-</span>').click(decrementCb);

  //       if(getMobileOperatingSystem() == 'unknown') {
  //         $input.attr('type', 'textfield');
  //       }
  //       $input.before(decrementEl);
  //       $input.after(incrementEl);
  //     });
  //     $('.views-field-edit-quantity', context).each(function () {
  //       var $input = $(this).find('input'),
  //       incrementCb = function() {
  //         var newVal = parseInt($input.val()) + 1;
  //         $input.val(newVal);
  //       },
  //       incrementEl = $('<span class="add-to-cart-button add-to-cart-button-increment">+</span>').click(incrementCb),
  //       decrementCb = function() {
  //         var newVal = parseInt($input.val())  - 1;
  //         if(newVal >= 1) {
  //           $input.val(newVal);
  //         }
  //       },
  //       decrementEl = $('<span class="add-to-cart-button add-to-cart-button-decrement">-</span>').click(decrementCb);

  //       if(getMobileOperatingSystem() == 'unknown') {
  //         $input.attr('type', 'textfield');
  //       }
  //       $input.before(decrementEl);
  //       $input.after(incrementEl);
  //     });
  //   }
  // }

  // Drupal.behaviors.randomizeProducts = {
  //   attach: function (context, settings) {
  //     $('div.product-listing-page', context).once('randomize-products').each(function() {
  //       var $this = $(this),
  //           $wrapper = $this.find('.views-wrapper:first'),
  //           $elements = $wrapper.children();
  //           while ($elements.length) {
  //             $wrapper.append($elements.splice(Math.floor(Math.random() * $elements.length), 1)[0]);
  //           }
  //     });
  //   }
  // }

  // Drupal.behaviors.hideCouponCodeInCartView = {
  //   attach: function (context, settings) {
  //     // Move the input field, so that enter presses submits the correct button.
  //     // This problem will reappear if we allow the user to enter more than one coupon.
  //     var promo_code_wrapper_id = '#commerce_promotion_code-ajax-wrapper';
  //     var promo_code_form = $(promo_code_wrapper_id, context).parents('form');
  //     $(promo_code_wrapper_id, context).detach().prependTo(promo_code_form);

  //     var has_coupons = $('.coupon-redemption-form__coupons tr').length >= 1;

  //     var cart_message = $('.js-preview-cart-message', '#commerce_promotion_code-ajax-wrapper');
  //     if (cart_message.length === 0) {
  //       cart_message = $('.js-preview-cart-message')
  //         .clone()
  //         .css({'color': '#d48171', 'padding': '16px 0'})
  //         .prependTo('#commerce_promotion_code-ajax-wrapper');
  //     }

  //     $('.form-item-commerce-promotion-code-code', context).each(function() {
  //       function show_form() {
  //         $(this).hide();
  //         label.hide();
  //         apply_code.hide();
  //         submit.show();
  //         input.show().focus();
  //       }

  //       var label = $(this).find('label:first');

  //       var submit = $(this).parent()
  //         .find('input[name="apply_coupon"]:first')
  //         .hide();

  //       var input = $(this).find('input:first')
  //         .attr('placeholder', label.text())
  //         .hide();

  //       var apply_code = $('<span class="apply-coupon-show">' + Drupal.t('APPLY_COUPON_SHOW') + '</span>')
  //         .appendTo(this)
  //         .click(show_form);

  //       if (has_coupons) {
  //         $(this).hide();
  //       }
  //       if (cart_message.length >= 1) {
  //         show_form();
  //       }
  //     });
  //   }
  // };

}(Drupal, jQuery));

// Source: https://github.com/jserz/js_piece/blob/master/DOM/ParentNode/prepend()/prepend().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('prepend')) {
      return;
    }
    Object.defineProperty(item, 'prepend', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function prepend() {
        var argArr = Array.prototype.slice.call(arguments),
          docFrag = document.createDocumentFragment();

        argArr.forEach(function (argItem) {
          var isNode = argItem instanceof Node;
          docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
        });

        this.insertBefore(docFrag, this.firstChild);
      }
    });
  });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);
